module.exports = __webpack_public_path__ + "img/spoken_reading_voice3.02bd9bcb.svg";